import { cn } from '@anytag/shared-utils';
import { Textarea as AnyuiTextarea, TextareaProps as AnyuiTextareaProps } from '@anyui/core';

export type TextareaProps = React.ComponentPropsWithRef<'textarea'> & AnyuiTextareaProps;

export const Textarea = ({ ref, classNames, ...restProps }: TextareaProps) => (
  <AnyuiTextarea
    ref={ref as Parameters<typeof AnyuiTextarea>[0]['ref']}
    minRows={4}
    autoSize={false} // Using native textarea as default
    classNames={{ ...classNames, textarea: cn('min-h-20', classNames?.textarea) }}
    {...restProps}
  />
);
